import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DeviceDetectorService {

    isShowing: boolean = false;
    modal = new Subject<boolean>();

    constructor() {
        this.modal.subscribe((value) => {
            this.isShowing = value;
        });
    }

    // getModal() {
    //     return this.modal;
    // }
    open() {
        // this.isShowing = true;
        this.modal.next(true);
    }
    close() {
        // this.isShowing = false;
        this.modal.next(false);
    }


}



// WEBPACK FOOTER //
// ./src/app/device-detector/device-detector.service.ts